import type { FaireProductEntity } from "../../entity_types/product";

export const p_mdmsajeuha: FaireProductEntity = {
  token: "p_mdmsajeuha",
  type: "product",
  name: "0.08 Carat Padlock Diamond Statement Ring, Natural Diamond",
  brandToken: "b_tk6ffkngnw",
  brandName: "PureYou Jewelry",
  imageUrl:
    "https://cdn.faire.com/fastly/ff532c6077db9f5e4d761cca1e6e9713aec3a16194e2fdd3287c5bb0d3a59287.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a6191e0471a81701c9e430dcfb992d910cac3258952baf6250c89dc445b77b92.png",
    "https://cdn.faire.com/fastly/1695f87fd78b24c6d0453798c389ef22e89a7167bbc2648e9a5ff547ad541e74.png",
    "https://cdn.faire.com/fastly/c5dbbf501d6c498188cad0b4da30b43dc5b556514d5b6dc2175881caa69ad675.png",
    "https://cdn.faire.com/fastly/2c594c9a24537839419493d74977cf3856a9c9e8113732e05ec17127f91a24b8.png",
    "https://cdn.faire.com/fastly/0f0bcbaf9efc49f2f9787d311f239832bea30af2941ae82d2a87d7349295b7b4.png",
    "https://cdn.faire.com/fastly/ea7c33f6b0dbdf2b43bb6f2bbaff885eacf069f648764c6ed1bb81a362691081.png",
    "https://cdn.faire.com/fastly/ec4a2a9a889da3f4b4e9c33e5320570c24090a1a4da96500a2fda3b5b37649b8.png",
    "https://cdn.faire.com/fastly/d79a9b5763113330552c93e8f4d08d6ff3d732814e52097b08d470ab21c965ee.png",
    "https://cdn.faire.com/fastly/654a0f5992c678e2d301c152ff3bba53d60e5dfb56d456bd39b9a57a026410a6.png",
    "https://cdn.faire.com/fastly/4ba6ec9812d6dab14c38158b124dbdcb064a5a49dd85afb844162adb3f513c0c.png",
    "https://cdn.faire.com/fastly/14be61b4102f0920e0d9a1be6f924b017691974623230aa9c5e6939d76e3b3c5.png",
    "https://cdn.faire.com/fastly/ffdc122cfbb437b1eafef7ade4055f8a06aa627847963f6d1fa0c2576190cb3c.png",
    "https://cdn.faire.com/fastly/9bd31341f4b65d1257b76705e509083ad1fcf5d40753aad6944256e7bad61879.png",
    "https://cdn.faire.com/fastly/c25770624c74d0e1b3753436d4a988efab736f93cdfd36566706e8697c70c606.png",
  ],
  priceDollars: 1367.67,
  description:
    "Diamond Details :\nGemstone: Natural Diamond\nStone Shape: Round\nDiamond Carat Weight: 0.080\nColor: G-H\nCut: Excellent\nClarity: VS1/SI\n\nMetal Details :\nMetal Option: 14k & 18k Stamped Solid Gold\nAvailable in: Yellow Gold, White Gold, Rose Gold.\n\nAt PureYou, we are dedicated to excellent service and top-quality jewelry. Our diamonds are certified and crafted by experts. We offer custom designs, fair pricing, no MOQ, no middlemen, and uphold excellent craftsmanship. All pieces are hypoallergenic, nickel-free, handcrafted, and made to order, with full customization available. Also offered in Lab diamonds—message us anytime, we’re happy to help!\n\nLab-Diamond Variation Link - https://www.faire.com/product/p_vqwcupkkhf",
  tags: [],
  msrpDollars: 2462.36,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:00:15.030Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
